import { NavLink } from 'react-router-dom'
import { X, LogOut } from 'lucide-react'
import NavBadge from '../nav/NavBadge'
import type { MobileNavItem } from '../../types/navigation'

interface MoreMenuProps {
  moreItems: MobileNavItem[]
  getBadgeCount: (route: string) => number | null
  onClose: () => void
  onSignOut: () => void
}

export default function MoreMenu({ moreItems, getBadgeCount, onClose, onSignOut }: MoreMenuProps) {
  return (
    <div
      className="fixed inset-0 z-50 lg:hidden"
      style={{ background: 'rgba(0,0,0,0.4)' }}
      onClick={onClose}
    >
      <div
        className="absolute bottom-0 left-0 right-0 rounded-t-2xl p-4"
        style={{ background: 'var(--bg-card)', paddingBottom: 'max(32px, env(safe-area-inset-bottom, 32px))' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>More</h3>
          <button
            onClick={onClose}
            className="p-1"
            style={{ color: 'var(--text-muted)', background: 'none', border: 'none', cursor: 'pointer' }}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex flex-col gap-0.5">
          {moreItems.map(({ to, icon, label }) => {
            const badgeCount = getBadgeCount(to)
            return (
              <NavLink
                key={to}
                to={to}
                onClick={onClose}
                className="flex items-center gap-3 py-2.5 px-3 rounded-xl transition active:scale-[0.98]"
                style={({ isActive }) => ({
                  background: isActive ? 'var(--color-accent-muted)' : 'transparent',
                  color: isActive ? 'var(--color-accent)' : 'var(--text-primary)',
                })}
              >
                <span
                  className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 text-lg"
                  style={{ background: 'var(--bg-surface)' }}
                >
                  {icon}
                </span>
                <span className="text-sm font-medium flex-1">{label}</span>
                <NavBadge visible={badgeCount !== null && badgeCount > 0} />
              </NavLink>
            )
          })}
        </div>
        <div className="mt-3 pt-3" style={{ borderTop: '1px solid var(--border-color)' }}>
          <button
            onClick={() => { onClose(); onSignOut() }}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl transition"
            style={{ background: 'none', color: 'var(--text-muted)', border: 'none', cursor: 'pointer' }}
          >
            <span
              className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
              style={{ background: 'var(--bg-surface)' }}
            >
              <LogOut className="w-4.5 h-4.5" />
            </span>
            <span className="text-sm font-medium">Sign out</span>
          </button>
        </div>
      </div>
    </div>
  )
}
